export default {
  namespaced: true,
  users_rh: {
    title: "Users Rh",
    soeid: "SOEID",
    name: "Name",
    first_name: "First name",
    second_name: "Second name",
    email: "Email",
  }
};